'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { MaxWidthWrapper } from '@/components/max-width-wrapper';
import { cn } from '@/lib/utils';
import { Menu } from './menu';
interface NavbarClientProps {
  logo: React.ReactNode;
  actions: React.ReactNode;
}
export function NavbarClient(t0) {
  const $ = _c(15);
  const {
    logo,
    actions
  } = t0;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn(["sticky top-0 z-60 h-(--navbar-height) w-dialog-viewport", "bg-black text-white"]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-4"><Menu onOpenChange={setIsMenuOpen} /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isMenuOpen ? "pointer-events-none opacity-0" : "opacity-100";
  let t4;
  if ($[2] !== t3) {
    t4 = cn(["absolute left-1/2 flex h-full -translate-x-1/2 items-center px-16 sm:px-20", "transition-opacity duration-300", t3]);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== logo || $[5] !== t4) {
    t5 = <div className={t4}>{logo}</div>;
    $[4] = logo;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = isMenuOpen ? "pointer-events-none opacity-0" : "opacity-100";
  let t7;
  if ($[7] !== t6) {
    t7 = cn(["transition-opacity duration-300", t6]);
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== actions || $[10] !== t7) {
    t8 = <div className={t7}>{actions}</div>;
    $[9] = actions;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <header className={t1}><MaxWidthWrapper size="xl" className="relative flex h-full items-center justify-between">{t2}{t5}{t8}</MaxWidthWrapper></header>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}